import React, { useMemo, useEffect, useState } from 'react';


const LINE_COUNT = 14;

const PageBackground: React.FC<{ children: React.ReactNode }> = React.memo(({ children }) => {
  const [animReady, setAnimReady] = useState(false);

  useEffect(() => {
    const cb = () => setAnimReady(true);
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(cb, { timeout: 3000 });
    } else {
      setTimeout(cb, 2000);
    }
  }, []);

  const lines = useMemo(() =>
    Array.from({ length: LINE_COUNT }, (_, i) => ({
      d1: `M 0,${55 + i * 27} Q 250,${105 + i * 27 + Math.sin(i * 0.9) * 38} 500,${55 + i * 27}`,
      d2: `M 500,${55 + i * 27} Q 250,${105 + i * 27 + Math.sin(i * 0.9) * 38} 0,${55 + i * 27}`,
      delay:    `${(i * 0.13).toFixed(2)}s`,
      duration: `${(3.5 + (i % 3) * 0.8).toFixed(1)}s`,
    })),
  []);


  return (
    <>
      <div id="fincal-bg" aria-hidden="true">
        <div className="orb orb-1" />
        <div className="orb orb-2" />

        <svg className="lines-left" viewBox="0 0 500 800" preserveAspectRatio="none">
          <defs>
            <linearGradient id="fincal-lg-left" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%"   stopColor="#3b82f6" stopOpacity="0" />
              <stop offset="50%"  stopColor="#8b5cf6" stopOpacity="0.65" />
              <stop offset="100%" stopColor="#ec4899" stopOpacity="0" />
            </linearGradient>
          </defs>
          {lines.map((l, i) => (
            <path key={i} d={l.d1} stroke="url(#fincal-lg-left)" strokeWidth="1" fill="none" />
          ))}
        </svg>

        <svg className="lines-right" viewBox="0 0 500 800" preserveAspectRatio="none">
          <defs>
            <linearGradient id="fincal-lg-right" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%"   stopColor="#ec4899" stopOpacity="0" />
              <stop offset="50%"  stopColor="#8b5cf6" stopOpacity="0.65" />
              <stop offset="100%" stopColor="#3b82f6" stopOpacity="0" />
            </linearGradient>
          </defs>
          {lines.map((l, i) => (
            <path key={i} d={l.d2} stroke="url(#fincal-lg-right)" strokeWidth="1" fill="none" />
          ))}
        </svg>
      </div>

      <div style={{ position: 'relative', zIndex: 1, minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
        {children}
      </div>
    </>
  );
});

export default PageBackground;
